<p-toolbar styleClass="mb-4 gap-2">
    <ng-template pTemplate="left">
        <p-button severity="success" label="New" icon="pi pi-plus" class="mr-2" (onClick)="addNew()" />
    </ng-template>

    <ng-template pTemplate="right">

    </ng-template>
</p-toolbar>

<p-table [value]="data" styleClass="p-datatable-striped" [tableStyle]="{'min-width': '50rem'}" selectionMode="single"
    [(selection)]="selectedItem" dataKey="id" [scrollable]="true" scrollHeight="flex">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Name </th>
            <th>Is Active</th>
            <th>Date Activated</th>
            <th>Pipedrive Label</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-columns="columns">
        <tr>
            <td>
                {{item.name}}
            </td>

            <td>
                {{item.isActive}}
            </td>
            <td>
                {{item.dateActivated | date: 'dd/MM/yyyy'}}
            </td>
            <td>
                {{item.crmLabelName}}
            </td>
            <td>
                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [outlined]="true" severity="success"
                    (onClick)="edit(item)" />
            </td>
        </tr>
    </ng-template>
</p-table>